export const getDefaultsForGame = (
  sectionId: string,
  config: any,
  userName: string
) => {
  const gameKey = sectionId.split(":")[1];

  switch (gameKey) {
    case "mpirimpa_cy":
    case "mpirimpa_el":
      return {
        name: userName,
        bet: config.bet.default,
        turnTime: config.turnTime.default,
        points: config.points.default,
        players: config?.twoVsTwo ? "TWO_VS_TWO" : "ONE_VS_ONE",
        type: "PRIVATE",
        groupCardSets: config.groupCardSets ?? false,
      };
    case "tichu":
      return {
        bet: config.bet.default,
        name: userName,
        points: config.points.default,
        sectionId: sectionId,
        turnTime: config.turnTime.default,
        type: "PRIVATE",
      };
    case "backgammon_classic":
    case "backgammon_portes":
      return {
        bet: config.bet.default,
        maxRoundNumber: config.bet.maxRoundNumber,
        name: userName,
        sectionId: sectionId,
        turnTime: config.turnTime.default,
        type: "PRIVATE",
      };
    case "belote":
      return {
        avoidPutTrumpOption: false,
        bet: config.bet.default,
        name: userName,
        players: "ONE_VS_ONE",
        points: config.points.default,
        sectionId: sectionId,
        turnTime: config.turnTime.default,
        type: "PRIVATE",
      };
    case "coinche":
      return {
        avoidPutTrumpOption: false,
        bet: config.bet.default,
        name: userName,
        points: config.points.default,
        sectionId: sectionId,
        turnTime: config.turnTime.default,
        type: "PRIVATE",
      };
    case "tictactoe":
      return {
        bet: config.bet.default,
        gridSize: config.gridSize.default,
        name: userName,
        sectionId: sectionId,
        turnTime: config.turnTime.default,
        type: "PRIVATE",
        winsToComplete: config.winsToComplete.default,
      };
    default:
      return {};
  }
};
